export default __webpack_public_path__ + "static/media/g-2.1483165b.jpg";